import React, { useState } from 'react';
import '../style/AboutUs.css';


export default function AboutUs() {
  return (
    <div className="about">
      <div className="about-us-container">
      <h1>About PenXV</h1>
      </div>

      <div className="section our-story">
        <h3>The Birth of PenXV</h3>
        <p>
          PenXV was founded on the belief that a pen is more than just a writing instrument—it's an extension of one's personality and style. Our journey began when our founder, a passionate writer and design enthusiast, discovered a lack of high-quality, stylish pens available in the market. This revelation led to the creation of PenXV, a company dedicated to designing and manufacturing exceptional pens that complement the individuality and professionalism of their users.
        </p>
      </div>

      <div className="section our-values">
        <h3>The Core Values that Define PenXV</h3>
        <p>
          At PenXV, we are driven by a set of core values that shape every aspect of our business, from design to customer service. Our values include:
        </p>
        <div className="metrics-container">
  <div className="metrics-row">
    <div className="metric-card">
      <h4>Commitment to Quality</h4>
      <p>We use only the finest materials and employ expert craftsmanship to create pens that are both durable and elegant.</p>
    </div>
    <div className="metric-card">
      <h4>Attention to Detail</h4>
      <p>Our meticulous design process ensures that every PenXV provides a comfortable and enjoyable writing experience.</p>
    </div>
    <div className="metric-card">
      <h4>Attention to Detail</h4>
      <p>Our meticulous design process ensures that every PenXV provides a comfortable and enjoyable writing experience.</p>
    </div>
    <div className="metric-card">
      <h4>Innovation</h4>
      <p>We continuously strive to innovate and improve our products, incorporating the latest technology and design trends.</p>
    </div>
  </div>
  <div className="metrics-row">
    <div className="metric-card">
      <h4>Customer Satisfaction</h4>
      <p>We place our customers at the heart of everything we do, working tirelessly to ensure their complete satisfaction with our products and services.</p>
    </div>
    <div className="metric-card">
      <h4>Environmental Responsibility</h4>
      <p>We are dedicated to minimizing our environmental footprint and use sustainable and eco-friendly materials and processes wherever possible.</p>
    </div>
  </div>
</div>
      </div>




      <div className="section our-process">
        <h3>Meticulous Design & Craftsmanship</h3>
        <p>
          Every PenXV begins with a vision—inspired by timeless design principles and a desire for unparalleled functionality. Our talented team of designers and engineers work in harmony to create unique pen designs that are both visually stunning and ergonomically superior. Once the design is perfected, our skilled artisans bring the pen to life, crafting each component with precision and care. The result is a writing instrument that not only looks exquisite but also performs flawlessly.
        </p>
      </div>

      <div className="section education-literacy">
  <h3>PenXV's Commitment to Education & Literacy</h3>
  <div className="education-literacy-content"> {/* Add this wrapper div */}
    <img src="https://www.usnews.com/object/image/00000180-75cb-d55a-a5ef-77cf7d400000/gettyimages-623911912.jpg?update-time=1651243711174&size=responsive640" alt="Education and Literacy" />
    <p>
      At PenXV, we believe in the power of the written word and are committed to promoting education and literacy worldwide. We proudly support various organizations and initiatives focused on improving access to education and learning resources for children and adults in need. With every PenXV purchase, a portion of the proceeds is donated to these deserving causes.
    </p>
  </div>
</div>


      <div className="section join-community">
        <h3>Stay Connected with PenXV</h3>
        <p>
          We invite you to join our growing community of pen enthusiasts, collectors, and professionals who share our passion for exquisite writing instruments. Stay up-to-date with the latest PenXV news, product releases, and special offers by signing up for our newsletter and following us on social media.
        </p>
        <div className="cta-button">
          <button>Subscribe to Our Newsletter</button>
        </div>
      </div>
    </div>
  );
}
